import {gql} from "@apollo/client";

export const FGM_MONITORING_GROUP_FIELDS = gql`
  fragment MonitoringGroupFields on MonitoringServiceGroup {
    group
    types {
      name
      display
    }
  }
`;
